import {
  Fieldset,
  media,
  spacing,
} from "@ops-gsic/cxp-component-library-react";
import { styled } from "styled-components";

export const SPFieldset = styled(Fieldset)`
  legend {
    margin-bottom: ${spacing.spacing4};

    @media ${media.small} {
      margin-bottom: ${spacing.spacing5};
    }
  }
  .sp-radio-group {
    margin-bottom: ${spacing.spacing5};
  }
  .sp-input {
    input {
      margin-bottom: ${spacing.spacing8};
    }
  }
  .sp-phone-input {
    margin-bottom: 0;
  }
  .sp-insurance-input {
    margin-bottom: ${spacing.spacing5};

    @media ${media.small} {
      margin-bottom: ${spacing.spacing7};
    }
  }
`;
export const SectionWrapper = styled.div`
  margin-top: ${spacing.spacing5};

  @media ${media.small} {
    margin-top: ${spacing.spacing7};
  }
`;

export const SectionContentWrapper = styled.div`
  margin-top: ${spacing.spacing4};

  @media ${media.small} {
    margin-top: ${spacing.spacing5};
  }
`;
export const ButtonContainer = styled.div`
  button {
    margin-bottom: ${spacing.spacing7};
  }
`;
